import { Heading, Typography } from '@altify/components';
import { useContent } from '@altify/utils';
import { content } from '../AiInsights.content';
import { SummaryPoint } from '../types';

interface SummaryBoxProps {
  summary: string;
  points: SummaryPoint[];
}

/**
 * Displays the summary section with key points
 */
export function SummaryBox({ summary, points }: SummaryBoxProps) {
  const localizedContent = useContent(content);

  return (
    <div className="rounded-3xl bg-neutral-500 p-4 mt-0 mb-4">
      <Heading level={5}>{localizedContent.summary}</Heading>
      <Typography size="medium" className="mt-1 mb-4">
        {summary}
      </Typography>
      <div className="flex flex-col gap-4">
        {points.map((item, index) => (
          <div className="flex flex-row gap-6" key={index}>
            <Typography weight="bold" size="large">
              {index + 1}.
            </Typography>
            <div className="flex flex-col">
              <Typography weight="bold" size="large">
                {item.title}
              </Typography>
              <Typography size="medium">{item.summary}</Typography>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
